<template>
  <div class="protocol-container">
    <div class="logo-wrap">
      <router-link :to="{ name: 'Home' }">
        <img class="header-img" src="../../assets/images/logo.png" alt="" />
      </router-link>
    </div>
    <div class="agreement-content">
      <h1>魔果云课机构服务合作协议</h1>
      <p>更新日期：2024年06月10日</p>
      <p>
        欢迎您使用北京闵氏超体网络科技有限公司(以下简称“魔果”)所提供的魔果云课服务（以下或称“本服务”），魔果云课是一个为独立的知识传授者、分享者提供完善的在线教育工具和平台能力，为求知者提供丰富的知识内容和一起学习的社群环境的实时互动教育平台。
      </p>
      <p>
        为获得魔果云课服务，您应当阅读并遵守《魔果云课服务合作协议》（以下简称“本协议”）、等相关规则，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议、规则。
      </p>
      <p>
        除非您已阅读并接受本协议及相关协议、规则等所有条款，否则，您无权使用本服务。您使用本服务，即视为您已阅读并同意上述协议、规则等的约束。您有违反本协议的任何行为时，魔果有权依照违反情况，随时单方限制、中止或终止向您提供本服务，并有权追究您的相关责任。
      </p>

      <h2>1.术语含义</h2>
      <p>如无特别说明，下列术语在本协议中的含义为：</p>
      <p>
        <b>1.1知识分享者：</b>
        指经有效注册、申请后，将其享有相应权利的各种知识接入魔果云课并向用户提供各种免费或收费类的在线互动教学、点播服务以实现与用户进行在线交流与学习目的的个人、法人或其他组织，因前述主体的不同，知识分享者对外也称“机构”或“知识分享者”，本协议中简称为“您”或“分享者”，其中分享者指个人，机构指法人或其他组织。
      </p>
      <p>
        <b>1.2知识内容：</b>
        指由分享者开发，或分享者经权利人授权，通过魔果云课向相关用户提供各种免费或收费类的互动教学、点播形式的交流与学习服务，包括但不限于会计类、网络营销类、公务员考试类、语言类等现有的各种培训服务及今后可能出现的各种培训服务。
      </p>
      <p>
        <b>1.3魔果：</b>
        指北京闵氏超体网络科技有限公司，由其独立控制、运营的魔果云课服务平台（www.comettech.com及魔果云课软件）
      </p>
      <p>
        <b>1.4魔果云课：</b>
        指魔果通过魔果云课服务平台（www.comettech.com及魔果云课软件）向您提供的服务包括但不限于提供互动教学平台、费用支付服务等服务，具体以魔果和您选择的服务约定为准。
      </p>
      <p><b>魔果、分享者均同意和理解：</b></p>
      <div class="list-wrap">
        <p>
          <b
            >（1）<span class="underline"
              >魔果云课是一个中立的平台服务提供方，</span
            > </b
          >仅向分享者提供信息存储空间、在线传播等中立的网络服务或相关中立的技术支持服务，以供分享者在中立的平台上自主发布、推广其知识内容等；
        </p>
        <p>
          （2）<b
            >分享者的知识内容<span class="underline"
              >由分享者自主开发、发布并独立承担全部责任；</span
            >
          </b>
        </p>
        <p>
          <b
            >（3）因分享者分享内容及服务产生的任何纠纷、责任等，以及分享着违反相关法律法规或本协议约定引发的任何后果，
            <span class="underline"
              >均由分享者独立承担责任、赔偿损失，与魔果云课无关</span
            >
            。如侵害到魔果云课、魔果及其关联公司或他人权益的，分享者须自行承担全部责任和赔偿一切损失。</b
          >
        </p>
      </div>
      <p>
        1.5
        <b>魔果云课运营数据：</b
        >是指用户、分享者在使用魔果云课相关服务中产生的相关运营数据，包括但不限于用户或分享者操作行为形成的数据、各类交易数据等，“魔果云课数据”、“平台数据、“运营数据”。“魔果云课运营数据”的所有权及其他相关权利属于魔果，且是魔果的商业秘密，未经魔果书面授权您不得使用。但依法属于用户、分享者享有相关权利的数据或分享内容等除外。
      </p>
      <p>
        1.6
        <b>机构：</b
        >是指在分享者开设的魔果云课分享中，具体提供交流与学习服务的法人或其他组织。
      </p>
      <p>
        1.7
        <b> 分享者：</b>
        是指在分享者开设的魔果云课分享中，具体提供交流与学习服务的个人。机构邀请分享者并以机构自己名义发布分享者的知识内容的，由机构承担全部责任。
      </p>
      <h2>2.分享者的权利和义务</h2>
      <h3>2.1帐号注册</h3>
      <p>
        2.1.1您应当通过登录魔果云课网站、软件或魔果指定的其他途径，注册分享者帐号（下简称：魔果云课帐号）以成为分享者，魔果云课帐号一经注册成功，该帐号不可转让、不可赠与、不可继承等。
      </p>
      <p>
        2.1.2<b>
          您不得违反本协议约定将您的魔果云课帐号用于其他目的。否则，魔果有权随时单方限制、中止或终止向您提供本服务，且未经魔果同意您不得再次使用本服务。</b
        >
      </p>
      <p>
        2.1.3您注册的魔果云课帐号，是您登录及使用本服务的凭证。
        <b
          >您应当做好魔果云课帐号、密码，以及进入和管理本服务中的各类产品与服务的口令、密码等的保密措施。因您保密措施不当或您的其他行为，致使上述口令、密码等丢失或泄漏所引起的一切损失和后果，
          <span class="underline">均由您自行承担。</span>
        </b>
      </p>
      <p>
        2.1.4
        <b
          >魔果云课可能根据您的申请提供添加其他魔果云课帐号以承担您注册帐号的帐号管理员的功能。帐号管理员有权以您账户的名义进行操作，您申请添加或邀请帐号管理员视为您了解并确认帐号管理员代表您操作帐号，
          <span class="underline">管理员的所有操作行为由您承担责任。</span>
        </b>
      </p>
      <p>
        2.1.5
        <b
          >您保证：您注册本服务的帐号及您添加的帐号管理员使用的魔果云课帐号的使用权均是合法获取的。</b
        >
        前述全部魔果云课帐号在本服务中进行的包括但不限于以下事项：注册本服务帐号、提交相应资质材料、确认和同意相关协议和规则、选择具体服务类别以及进行费用结算等事项，均是您自行或您授权他人进行的行为，对您均有约束力。
        <b
          >同时，您承担以前述全部魔果云课帐号为标识进行的全部行为的法律责任。</b
        >
      </p>
      <p>
        2.1.6您保证不得通过任何手段恶意注册魔果云课帐号，包括但不限于以牟利、炒作、套现、获奖等为目的多个帐号注册，亦不得盗用其他用户帐号。
        <b
          >如您违反上述规定，则魔果有权直接采取一切必要的措施，包括但不限于删除您发布的内容、暂停或查封用户帐号，取消因违规所获利益，以及通过诉讼形式追究您法律责任等。</b
        >
      </p>
      <p>
        2.1.7若您发现有他人冒用或盗用您的帐号及密码、或任何其他未经您合法授权的情形时，您应立即以有效方式通知魔果并提供魔果所需的相关材料（包括但不限于提供您的身份信息和相关身份资料、相关事实情况及您的要求等）。
        <b
          >魔果收到您的有效请求并核实身份后，会根据不同情况采取相应措施。若您提供的信息不完全，导致魔果无法核实您的身份或魔果无法判断您的需求等，而导致魔果无法进行及时处理，给您带来的损失，您应自行承担。同时，魔果对您的请求采取措施需要合理期限，对于您通知魔果以及魔果根据您的有效通知采取措施之前，由于他人行为给您造成的损失，魔果不承担任何责任。</b
        >
      </p>
      <h3>2.2资质材料及认证</h3>
      <p>
        2.2.1
        <b>您保证：</b>
        您具备使用本服务、接入和运营知识内容或提供相关服务等行为的相关合法资质或已经过了相关政府部门的审核批准；您提供的主体资质材料、相关资质或证明以及其他任何文件等信息真实、准确、完整，并在信息发生变更后，及时进行更新；您具备履行本协议项下之义务、各种行为的能力；您履行相关义务、从事相关行为不违反任何对您的有约束力的法律文件。
        <b>
          否则，您应不使用魔果提供的相关服务，且应独自承担由此带来的一切责任及给用户、魔果造成的全部损失。</b
        >
      </p>
      <p>
        2.2.2
        <b
          >您保证：您会依法及按照魔果要求提交使用本服务所必须的真实、准确的经过您签章确认的主体资质材料以及
          <span class="underline"
            >联系人姓名（名称）、身份证号码、地址、电子邮箱等相关资料。</span
          >
        </b>
      </p>
      <p>
        2.2.3
        <b>
          您保证：您在魔果云课上通过您的分享提供的各种服务，依法已经具有相关的合法资质或获得了有关部门的许可或批准，并在必要时可以向平台提交相关资质或证明文件。</b
        >
      </p>
      <p>
        2.2.4
        <b
          >您保证：您在魔果云课上通过您的分享提供的各种服务，符合国家相关法规的规定，不违反任何相关法规及相关协议、规则，也不会侵犯任何人的合法权益，同时，会依法、依约或按照魔果的要求在必要时提供版权、专利权等相关证明文件。</b
        >
      </p>
      <p>
        2.2.5
        <b>
          您保证：在您以包括个人或机构身份开设的魔果云课知识分享中，提供服务的分享者均具有相应的合法资质和符合提供分享服务的相应能力，并对分享者在分享中的一切行为承担责任及承担给用户、魔果造成的全部损失。同时您应当自行解决与分享者的一切事宜，包括但不限于分享者资质的验证、分享者在提供分享服务过程中报酬的支付等事宜，
          <span class="underline">与魔果无关。</span>
          同时您的发言仅代表您个人，<span class="underline"
            >并不代表魔果。</span
          ></b
        >
      </p>
      <p>
        2.2.6
        <b>您同意：</b>
        您将通过魔果云课的认证流程，提交相应的材料供魔果云课服务进行认证，若您是机构，您应按照要求提供（包含但不限于填写、上传等方式）如营业执照、所属公司、联系人等相关信息；若您是个人，应按照要求提供（包含但不限于填写、上传等方式）如个人身份信息、住址、联系方式等相关信息。您保证上述信息的真实性、有效性、合法性。认证通过后，您将完成入驻平台、开通交易支付等平台相关功能、服务。
        <b
          >若提供虚假信息，魔果有权在核实后终止对您提供在魔果云课中的各项服务。</b
        >
      </p>
      <p>
        2.2.7<b>您同意：</b>若您向魔果及其关联公司发起其项下产品以及服务使用申请时，该服务或者产品提供者有权调取您在魔果云课服务中所提交的相关认证资料，从而进行相关身份信息以及资质的认证。
      </p>
      <h3>2.3服务费用及结算方式</h3>
      <p>
        2.3.1魔果仅在平台提供平台功能相关的网络服务，除此之外的必要条件、相关设备、费用
        <span class="underline">均由您自行负担。</span>
      </p>
      <p>
        2.3.2您在魔果云课平台进行分享服务所获得的收益，魔果有权自行或委托第三方，包括但不限于银行、第三方支付公司等，按照<b
          ><span class="underline">《魔果云课结算说明》</span></b
        >与您进行结算。因前述委托第三方支付结算事宜所产生的服务费用，包括但不限于第三方服务费、渠道手续费等，由您自行承担，您同意魔果有权在结算时予以直接扣除。为委托第三方支付结算事宜，您同意授权魔果向第三方提供开具结算账户并进行代收付所必要的个人/企业信息（包括但不限于身份信息、营业执照、信用信息、联系信息等）。您应认真阅读上述《结算说明》，并确认收益、服务费用的结算流程以上述文档的最新版本为准。魔果《魔果云课结算说明》将作为本协议附件（详见附件），是本协议不可分割的一部分。
      </p>
      <p>
        2.3.3
        <b>
          您同意：在满足魔果《魔果云课结算说明》约定的付款条件后，魔果将与您进行结算。您对在魔果云课取得的服务收益自行承担税费，<b
            ><span class="underline">魔果不承担相关税费义务。</span></b
          ></b
        >
      </p>
      <p>
        您若对魔果提供的收费标准、服务使用期限、结算流程等费用结算事项的通知内容有异议的，应在收到魔果通知后及时以书面形式告知魔果，魔果收到您的书面告知会进行核实，否则，视为您认可魔果提供的费用结算事项的通知内容，双方应按照魔果提供的费用结算事项的通知内容，进行费用的结算及支付等。
      </p>
      <p>
        2.3.4魔果有权收取用户在平台通过第三方支付或代付收取费用的提成，魔果从前述支付或代付中提成的比例按照第三方支付或者代付收费说明为准。<b
          ><span class="underline"
            >魔果可通过修改本协议或其它书面方式变更前述比例。</span
          ></b
        >
      </p>
      <p>
        2.3.5
        <b
          >如后续魔果向您收取相应服务费用的，
          <span class="underline"
            >您因使用魔果提供的相关服务而产生的所有服务费用由您自行承担，</span
          >
          您应按相关协议、规则等的规定支付费用，
          <span class="underline">否则，魔果有权不提供相关服务。</span>
          您选择使用相关服务并支付费用后，在服务未到期之前，
          <span class="underline"
            >若您单方要求提前解除服务的，魔果有权将您未使用的服务对应的费用不予退还而作为您单方违约的违约金予以没收。</span
          >
        </b>
      </p>
      <p>
        <b
          >在本服务中，魔果如需对服务收取相应服务费用的，魔果有权单方根据实际需要对收费服务的收费标准、方式进行修改和变更，前述修改、变更前，魔果将在相应服务页面进行通知或公告。</b
        >您会予以全部遵守、同意。如果您不同意上述修改、变更，则应立即停止使用相应服务，否则，您的任何使用行为，即视为您同意上述修改、变更。
      </p>
      <h3>2.4分享要求</h3>
      <p>
        2.4.1
        <b
          >您应自行负责您分享内容的开发、创建、分享、管理、运营等工作，并且自行承担相应的费用。</b
        >
        如机构是聘任其他分享者（在魔果云课上会以魔果云课帐号的形式进行体现,您会与其他分享者的魔果云课帐号进行关联）进行相关分享交流的，则视分享者行为为机构的行为，机构应当对分享者的全部行为承担责任（包括但不限于管理分享者的分享安排、支付分享者相应费用等）。
        <b
          >如分享者存在违反法律法规或魔果相关规定的行为，则视同机构违反法律法规或魔果相关规定，包括《魔果云课直播服务协议》，魔果有权根据相关法律法规或魔果相关规定对机构进行相应的处罚。</b
        >
      </p>
      <p>
        2.4.2如机构聘任分享者进行相关分享交流的，机构应当保证已经自行与分享者签订了线下的并约定相关权利义务的相关协议（具体包括但不限于劳动合同、外包合同、聘用合同等），或机构已经妥善处理好了关于分享者的相关权利义务的事项，否则，机构应在处理好成为该机构与分享者相关权利义务事项之后，再确认本协议。
        <b
          >机构确认本协议的行为，视为机构已经处理好了与分享者相关权利义务的事项，由此产生的法律后果机构应自行承担，
          <span class="underline"
            >魔果无需向分享者支付任何费用且无需向分享者承担任何责任。</span
          >
        </b>
      </p>
      <p>
        2.4.3您的分享，应符合相关法规、技术规范或标准等，同时，还应符合魔果云课的对接入的分享知识在内容、服务等方面的统一要求和您在知识分享介绍页面对内容的介绍，以确保分享可以在魔果云课真实、安全、稳定的运营。
      </p>
      <p>
        2.4.4您不得在分享内宣传与本分享知识内容无关的任何其他信息，包括但不限于广告、其他的服务以及产品信息等（除非双方另有约定），也不得在分享内添加指向非魔果拥有或控制或魔果不同意的网站链接。
      </p>
      <p>
        2.4.5您的分享在魔果云课上运营期间，您需向用户提供及时有效的客户服务，客户服务形式包括但不限于通过明确且合理的方式告知用户客户服务渠道、提供电话等，<b
          ><span class="underline">并自行承担客服费用。</span>
        </b>
      </p>
      <p>
        2.4.6
        <b
          >您应当在分享中公开提供投诉途径，确保第三方在认为您侵犯其合法权益时可以向您主张权利。</b
        >
      </p>
      <p>
        2.4.7如果您的分享符合魔果云课支付接入的相关要求时，则可依相关规范、流程等接入到魔果的支付系统。
      </p>
      <p>
        2.4.8您有义务遵守您向用户提供的任何承诺和保证，有义务保证用户（包括付费用户、免费用户）能在相关服务的魔果云课中正常、不受任何影响的享受您提供的相关服务。
      </p>
      <p>
        2.4.9
        <b
          >您对自己在魔果发布的所有带有商业广告特征的文字、图片等宣传推广信息的真实性负责，并承担《中华人民共和国广告法》所指的广告主及/或广告发布者责任。魔果对前述信息仅承担《中华人民共和国广告法》所指的互联网信息服务提供者的责任。</b
        >
        对您利用魔果发布违法违规广告的行为，魔果有权制止，制止措施包括但不限于删除违法违规广告、下架相关分享知识等。对于您利用魔果发布违法违规广告的行为造成魔果经济或名誉损失的，魔果保留进一步追究责任的权利，您需要赔偿魔果因此承受的一切直接及间接损失（无论魔果就您发布广告事宜是否曾向您收取费用）。
      </p>
      <h3>2.5分享发布</h3>
      <p>
        2.5.1您应自行按照相关法规发布您的分享内容，履行相关义务，并自行承担全部责任，包括但不限于：
      </p>
      <div class="list-wrap">
        <p>（1）依照相关法律法规的规定，保留相应的访问、使用等日志记录；</p>
        <p>（2）国家有权机关向您依法查询相关信息时，应积极配合提供；</p>
        <p>
          （3）主动履行其他您依法应履行的义务。遵守魔果平台其它包括《魔果云课直播服务协议》，如出现违规，魔果有权根据相关法律法规或魔果相关规定对您进行相应的处罚。
        </p>
      </div>
      <p>2.5.2<b>您保证：</b></p>
      <div class="list-wrap">
        <p>
          （1）您的分享、提供给用户的相关服务及发布的相关信息、内容等，不违反相关法律、法规、政策等的规定及本协议或相关协议、规则等，也不会侵犯任何人的合法权益；
        </p>
        <p>
          （2）尊重用户知情权、选择权，应当坚持诚信原则，不误导、欺诈、混淆用户，尊重用户的隐私，不骚扰用户，不制造垃圾信息。
        </p>
        <p>
          （3）如您的股东或高级管理人员（包括但不限于董事长、总经理、财务总监等）同时也为魔果及关联公司的员工（包括魔果及关联公司的试用期员工、正式员工、劳务派遣形式的员工及其他受魔果及关联公司管理的其他性质的员工或人员）时，您应当在注册时主动书面告知魔果。
        </p>
      </div>

      <p>
        2.5.3您不得从事任何包括但不限于以下的违反法规的行为，也不得为以下违反法规的行为提供便利（包括但不限于为购买您分享服务的用户的行为提供便利等）：
      </p>
      <div class="list-wrap">
        <p>（1）反对宪法所确定的基本原则的行为；</p>
        <p>
          （2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的行为；
        </p>
        <p>（3）损害国家荣誉和利益的行为；</p>
        <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的行为；</p>
        <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的行为；</p>
        <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的行为；</p>
        <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的行为；</p>
        <p>（8）侮辱或者诽谤他人，侵害他人合法权益的行为；</p>
        <p>（9）侵害他人知识产权、商业秘密等合法权利的行为；</p>
        <p>（10）恶意虚构事实、隐瞒真相以误导、欺骗他人的行为；</p>
        <p>（11）发布、传送、传播广告信息及垃圾信息；</p>
        <p>（12）其他法律法规禁止的行为。</p>
      </div>
      <p>
        2.5.4您不得从事包括但不限于以下行为，也不得为以下行为提供便利（包括但不限于为您的用户的行为提供便利等）：
      </p>
      <div class="list-wrap">
        <p>
          （1）删除、隐匿、改变魔果云课显示或其中包含的任何专利、著作权、商标或其他所有权声明；
        </p>
        <p>
          （2）以任何方式干扰或企图干扰魔果任何产品、任何部分或功能的正常运行，或者制作、发布、传播上述工具、方法等；
        </p>
        <p>
          （3）未经魔果书面许可，您在分享内容中不得使用包括但不限于“魔果”、“魔果云课”其他魔果及其关联公司商标标识或其任何变体、缩写、改写等；
        </p>
        <p>
          （4）避开、尝试避开或声称能够避开任何内容保护机制，或导致用户认为其直接与魔果云课及魔果相关产品进行交互；
        </p>
        <p>
          （5）在未获得魔果书面许可的情况下，以任何方式使用魔果URL地址、技术接口等；
        </p>
        <p>
          （6）在未经过用户同意的情况下，向任何其他用户及他方显示或以其他任何方式提供该用户的任何信息；
        </p>
        <p>
          （7）请求、收集、索取或以其他方式获取用户魔果云课帐号、密码或其他任何身份验证凭据；
        </p>
        <p>
          （8）在没有获得用户明示同意的情况下，直接联系用户，或向用户发布任何商业广告及骚扰信息；
        </p>
        <p>（9）为任何用户自动登录到魔果云课提供代理身份验证凭据；</p>
        <p>
          （10）提供跟踪功能，包括但不限于识别其他用户在个人主页上查看、点击等操作行为；
        </p>
        <p>（11）自动将浏览器窗口定向到其他网页；</p>
        <p>（12）未经授权获取对魔果产品或服务的访问权；</p>
        <p>
          （13）知识分享内容中含有计算机病毒、木马或其他恶意程序等任何可能危害魔果或用户权益和终端信息安全等的内容；
        </p>
        <p>
          （14）设置或发布任何违反相关法规、公序良俗、社会公德等的玩法、内容等；
        </p>
        <p>
          （15）公开表达或暗示，您与魔果之间存在合作关系，包括但不限于相互持股、商业往来或合作关系等，或声称魔果及其关联公司对您的认可；
        </p>
        <p>
          （16）未经魔果许可，实施包括但不限于以赠送、发售等方式使用魔果及其关联公司或第三方的任何虚拟货币或品牌服务（例如学币卡等）的行为；
        </p>
        <p>（17）其他魔果及其关联公司认为不应该、不适当的行为、内容。</p>
      </div>

      <p>
        2.5.5<b
          >本服务中可能会使用第三方软件或技术，若有使用，前述第三方软件或技术相关协议或其他文件，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。
          <span class="underline">否则，因此带来的一切责任您应自行承担。</span>
          如因本服务使用的第三方软件或技术引发的任何纠纷，由该第三方负责解决。</b
        >
      </p>
      <p>
        2.5.6您应当在您的分享服务的详情界面，对分享服务的内容、适合人群以及相关的退款政策、开票事宜向用户做出承诺与介绍，用户有权根据您的服务详情与您协商服务的购买、售后服务、退款、开票等事宜，
        <b>
          <span class="underline"
            >若协商不一致，您或用户都有权按照魔果《魔果云课结算说明》中的售后条款向魔果平台申诉，魔果有权视情况按照平台规则处理。</span
          ></b
        >
      </p>
      <p>
        2.5.7
        <b>您保证：</b>
        在本协议有效期内，您应保持作为知识分享者的积极向上、健康、乐观的正面形象，并应积极维护魔果的正面形象，不得有任何有损“魔果云课”品牌或其他魔果形象和利益的行为，不得有宣传魔果竞争对手或其他与分享内容无关的行为。
        <b
          ><span class="underline"
            >如有违反，魔果有权随时解除本协议，并有权在平台进行通报说明且拒绝结算费用及要求您赔偿由此给魔果造成的全部损失，包括但不限于诉讼费、律师费、赔偿经济损失等。</span
          ></b
        >
      </p>
      <p>
        2.5.8
        <b>您保证</b>
        ，在任何情况下都确保用户权益优先原则，您与魔果之间的任何争议都不得影响到已购买服务用户的学习权益。
      </p>
      <h3>2.6分享内容的下线规则</h3>
      <p>
        2.6.1您发布分享后，无论分享是否收费，在分享未按照您发布分享时的安排履行完毕的，或分享有用户已经报名但未学习完的，在未经已报名但未学习完用户和魔果都同意的前提下，
        <b> 您不得擅自终止分享服务的提供。</b>
      </p>
      <p>
        2.6.2您发布分享后，无论分享是否收费，在分享未按照您发布分享时的安排，或分享服务有用户已经报名但仍未学习完的，
        <b
          >若您确须要提前终止该分享运营或服务提供，您应至少提前通知并取得用户和魔果的同意。</b
        >
      </p>
      <p>
        2.6.3您发布分享后，无论分享是否收费，在分享未按照您发布分享时的安排，或分享有用户已经报名但仍未学习完的，
        <b
          >若您发布的分享由于违反相关法规或本协议相关约定，您应该按照魔果或魔果云课的要求终止分享的发布。魔果保留因其它原因随时终止分享的运营或服务的提供。</b
        >
        在前述情况下您都应妥善处理已报名但未学习完用户的退费、各类用户损失等问题，
        <b
          ><span class="underline"
            >若由此造成用户、魔果及其关联公司、魔果云课损失或有纠纷的，您应负责解决相关纠纷并自行承担全部责任。</span
          ></b
        >
      </p>
      <p>
        2.6.4若分享因为任何原因需要下线的，在分享下线过程中，您应积极与用用户联系并妥善处理已报名但未学习完用户的退费、各类用户损失等事宜，依法保护用户的合法权益不受损害，
        <b
          ><span class="underline">
            否则，若由此造成用户、魔果及其关联公司损失或有纠纷的，您应负责解决相关纠纷并自行承担全部责任。</span
          ></b
        >
        同时，您应发布下线公告直至分享下线（下线公告应当包含但不限于下线时间、退费方式、用户补偿方案、客服联系电话等内容），且您不得强制用户切换到其他第三方平台进行学习，亦不得免除自身对未结束分享进行退款责任等义务。
        <b
          >如您补偿用户损失的，您同意魔果在您的魔果云课帐号结算额中直接扣除前述补偿用户损失费用等全部费用，具体退款流程可参见魔果及其关联公司现有的或后续颁布的相关规则或说明。</b
        >
      </p>
      <h2>2.7关于用户数据的规则</h2>
      <p>
        2.7.1您的分享或其他服务对于用户数据的收集、保存、使用等必须满足以下要求：
      </p>
      <div class="list-wrap">
        <p>
          （1）您的分享或其他服务需要收集用户任何数据的，必须事先获得用户的明确同意，且仅应当收集为分享运行而必要的用户数据，同时应当告知用户相关数据收集的目的、范围及使用方式等，保障用户知情权；
        </p>
        <p>
          （2）您收集用户的数据后，必须采取必要的保护措施，防止用户数据被盗、泄漏等；
        </p>
        <p>
          （3）您在特定分享中收集的用户数据仅可以在该特定分享中使用，不得将其使用在该特定分享之外或为其他任何目的进行使用，也不得以任何方式将其提供给他人；
        </p>
        <p>
          （4）您应向用户提供隐私保护政策。隐私保护政策须在分享界面上明显位置向用户展示；
        </p>
      </div>

      <p>
        2.7.2您不得收集用户的隐私信息数据及其他魔果及其关联公司认为属于敏感信息范畴的数据，包括但不限于不得收集或要求用户提供任何魔果云课帐号、密码、用户关系链、好友列表数据、银行账号和密码等。
      </p>
      <p>2.7.3您不得使用魔果云课数据用于向用户进行广告宣传使用。</p>
      <p>
        2.7.4如果魔果及其关联公司认为您收集、使用用户数据的方式，可能损害用户体验，魔果有权要求您删除相关数据并不得再以该方式收集、使用用户数据。
      </p>
      <p>2.7.5魔果有权限制或阻止您获取用户数据及魔果云课数据。</p>
      <p>
        2.7.6未经魔果事先书面同意，您不得为本协议约定之外的目的使用用户数据或平台运营数据，亦不得以任何形式将前述数据提供给他人。
      </p>
      <p>
        2.7.7一旦分享者停止使用魔果云课，或魔果基于任何原因终止您使用本服务，您必须立即删除全部从魔果云课中获得的数据（包括各种备份），且不得再以任何方式进行使用。
      </p>
      <p>
        2.7.8您应自行对因使用本服务而存储在魔果及其关联公司服务器的各类数据等信息，在本服务之外，采取合理、安全的技术措施，确保其安全性，
        <b
          ><span class="underline">
            并对自己的行为（包括但不限于自行安装软件、采取加密措施或进行其他安全措施等）所引起的结果承担全部责任。</span
          ></b
        >
      </p>
      <h2>2.8法律责任</h2>
      <p>
        2.8.1
        <b>您保证：</b>
        如果您使用本服务产生相应费用的，您会按照本协议及相关协议、规则等支付相关费用。否则，您理解并同意：
        <b>每延期一日，您应当向魔果支付所欠费用千分之一的违约金。</b>
        同时，魔果有权随时单方采取包括但不限于以下措施中的一种或多种，以维护自己的合法权益。
      </p>
      <div class="list-wrap">
        <p>（1）从其他魔果应支付给您或您关联公司的任何费用中直接抵扣；</p>
        <p>（2）暂停向您或您关联公司结算或支付任何费用；</p>
        <p>（3）中止、终止您或您关联公司使用本服务；</p>
        <p>（4）中止、终止您或您关联公司的后台管理权限；</p>
        <p>（5）删除您或您关联公司在使用本服务中存储的任何数据；</p>
        <p>（6）禁止您今后将您的任何新分享服务接入魔果云课；</p>
        <p>（7）其他魔果可以采取的为维护自己权益的措施。</p>
      </div>

      <p>
        2.8.2
        <b>您理解并同意：</b>
        您应当遵守服务协议以及规则，按设定的时间完成分享服务。如果您未能在约定日期之内完成分享服务，或未按照约定或者详情介绍的方式、内容提供服务的，
        <b>应当按照魔果所发布的相关规定进行处理。</b>
      </p>
      <p>
        2.8.3
        <b>您保证：</b>
        您使用本服务及您的任何行为，不违反任何相关法规、本协议和相关协议、规则等。
      </p>
      <p>
        <b>您理解并同意：</b>
        若魔果自行发现或根据相关部门的信息、权利人的投诉等发现您可能存在违反前述保证情形的，魔果有权根据《侵权责任法》、《著作权法》、《信息网络传播权保护条例》，以一般人的认识做独立判断，以认定您是否存在违反前述保证情形，
        <b>
          若魔果经过判断认为您存在违反前述保证情形的，魔果有权随时单方采取以下一项或多项措施。</b
        >
      </p>
      <div class="list-wrap">
        <p>（1）要求您立即更换、修改违反前述保证情形的相关内容；</p>
        <p>
          （2）对存在违反前述保证情形的分享、您或您关联公司名下的全部分享服务或任何一款分享采取下线措施即终止分享服务在魔果云课的运营；
        </p>
        <p>（3）禁止您或您关联公司今后将任何新分享服务接入魔果云课；</p>
        <p>
          （4）中止、终止向违反前述保证情形的分享、您或您关联公司名下的全部分享或任何一款分享，或您或您关联公司提供部分或全部本服务；
        </p>
        <p>（5）追究您的法律责任；</p>
        <p>（6）将您的行为对外予以公告；</p>
        <p>（7）其他魔果认为适合的处理措施。</p>
      </div>

      <p>
        2.8.4
        <b
          >如您的分享或其它发布的作品被用户投诉，或因其它原因由魔果告知您或您自行得知您存在任何违法情形后，您应按法律法规或魔果的规定向魔果提出反通知、不侵权解释和担保。但是，无论魔果是否告知您、您是否提出反通知、解释或担保，或反通知是否符合相关法规、魔果要求等，均不影响魔果进行自己的独立判断和采取相关措施。</b
        >
      </p>
      <p>
        2.8.5
        <b
          >若魔果按照上述条款、本协议的其他相关约定或因您违反相关法律的规定，对您或您的分享采取任何行为或措施，所引起的纠纷、责任等一概由您自行负责，造成您损失的，您应自行全部承担，造成魔果及其关联公司或他人损失的，您也应自行承担全部责任。</b
        >
      </p>
      <p>
        2.8.6
        <b
          >若魔果按照上述条款、本协议的其他相关约定或因您违反相关法律的规定，对您或您的分享采取任何行为或措施后，导致您没有使用到相应服务但已经缴纳相应费用的，对该部分费用，魔果有权不予退还，而作为您违反约定的违约金予以没收。</b
        >
      </p>
      <h2>3.魔果的权利义务</h2>
      <p>
        3.1魔果会根据您选择的服务向您提供相应的服务，如后续魔果提供服务需要收费的，您应向魔果支付相应费用，魔果在您支付相应费用后，会向您提供相应的服务。
      </p>
      <p>
        3.2保护您的信息的安全是魔果的一项基本原则，未经您的同意，魔果不会向魔果及其关联公司以外的任何公司、组织和个人披露、提供您的信息，但下列情形除外：
      </p>
      <div class="list-wrap">
        <p>（1）据本协议或其他相关协议、规则等规定可以提供的；</p>
        <p>（2）依据法律法规的规定可以提供的；</p>
        <p>（3）行政、司法等政府部门要求提供的；</p>
        <p>（4）您同意魔果及其关联公司向第三方提供；</p>
        <p>（5）为解决举报事件、提起诉讼而需要提供的；</p>
        <p>
          （6）为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提供的。
        </p>
      </div>

      <p>
        3.3尽管魔果对您的信息保护做了极大的努力，但是仍然不能保证在现有的安全技术措施下，
        <b>
          您的信息可能会因为不可抗力或非魔果及因素造成泄漏、窃取等，由此给您造成损失的，您同意魔果及其关联公司可以免责。</b
        >
      </p>
      <p>
        3.4魔果有权开发、运营与您分享内容相似或相竞争的内容，同时魔果也不保证魔果云课上不会出现其他分享者提供同类分享内容。
      </p>
      <p>
        3.5享有有权在包括但不限于分享介绍页等，向用户阐述该分享为您开发以及由您向用户提供客户服务等。
      </p>
      <p>
        3.6
        <b>
          魔果可将本协议下的权利和义务的部分或全部转让给他人，如果您不同意魔果的该转让，则有权停止使用本协议下关联服务。否则，视为您对此予以接受。</b
        >
      </p>
      <p>
        3.7除了另行有约定外，魔果无需为按照本协议享有的权益而向您支付任何费用。
      </p>
      <p>
        3.8
        <b>您理解并同意：</b>
        为向更多互联网使用者推广您的分享，魔果及其关联公司有权采取以下行为，而无须再取得您的同意。
      </p>
      <div class="list-wrap">
        <p>
          （1）在魔果云课以外的平台、网站等采取各种形式对分享服务进行宣传、推广；
        </p>
        <p>
          （2）魔果及其关联公司可根据整体运营安排，自主选择向整个或部分全世界范围内的互联网用户提供您的分享；
        </p>
        <p>
          （3）有权为本协议目的使用您分享中的LOGO、标识、名称、图片等相关素材。
        </p>
      </div>

      <h2>4.关于免责</h2>
      <p>
        <b>4.1您理解并同意：</b
        >鉴于网络服务的特殊性，魔果及其关联公司有权在无需通知您的情况下根据魔果云课的整体运营情况或相关运营规范、规则等，可以随时变更、中止或终止部分或全部的服务，若由此给您造成损失的，您同意放弃追究魔果及其关联公司的责任。
      </p>
      <p>
        <b>4.2您理解并同意：</b>
        为了向您提供更完善的服务，魔果有权定期或不定期地对提供本服务的平台或相关设备进行检修、维护、升级等，此类情况可能会造成相关服务在合理时间内中断或暂停的，若由此给您造成损失的，您同意放弃追究魔果的责任。
      </p>
      <p>
        <b>4.3您理解并同意：</b>
        魔果的服务是按照现有技术和条件所能达到的现状提供的。魔果会尽最大努力向您提供服务，确保服务的连贯性和安全性；但魔果不能保证其所提供的服务毫无瑕疵，也无法随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。所以您也同意：即使魔果提供的服务存在瑕疵，但上述瑕疵是当时行业技术水平所无法避免的，其将不被视为魔果违约，同时，由此给您造成的数据或信息丢失等损失的，您同意放弃追究魔果的责任。
      </p>
      <p>
        <b>4.4您理解并同意：</b>
        在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，魔果将努力在第一时间与相关单位配合，及时进行修复，若由此给您造成损失的，您同意放弃追究魔果的责任。
      </p>
      <p>
        <b> 4.5您理解并同意： </b>
        若由于对以下情形导致的服务中断或受阻，给您造成损失的，您同意放弃追究魔果及其关联公司的责任：
      </p>
      <div class="list-wrap">
        <p>（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
        <p>
          （2）您或魔果及其关联公司的电脑软件、系统、硬件和通信线路出现故障；
        </p>
        <p>（3）您操作不当；</p>
        <p>（4）您通过非魔果授权的方式使用本服务；</p>
        <p>（5）其他魔果无法控制或合理预见的情形。</p>
      </div>

      <h2>5.服务的中止或终止</h2>
      <p>
        5.1如您书面通知魔果不接受本协议或对其的修改，魔果有权随时中止或终止向您提供本服务。
      </p>
      <p>
        5.2因不可抗力因素导致您无法继续使用本服务或魔果无法提供本服务的，魔果有权随时终止协议。
      </p>
      <p>
        5.3本协议约定的其他中止或终止条件发生或实现的，魔果有权随时中止或终止向您提供本服务。
      </p>
      <p>
        5.4由于您违反本协议约定，魔果依约终止向您提供本服务后，如您后续再直接或间接，或以他人名义注册使用本服务的，魔果有权直接单方面暂停或终止提供本服务。
      </p>
      <p>
        5.5如本协议或本服务因为任何原因终止的，对于您的帐号中的全部数据或您因使用本服务而存储在魔果及其关联公司服务器中的数据等任何信息，魔果可将该等信息保留或删除，包括服务终止前您尚未完成的任何数据。
      </p>
      <p>
        5.6如本协议或本服务因为任何原因终止的，您应自行处理好关于数据等信息的备份以及与您的用户之间的相关事项的处理等，由此造成魔果及其关联公司损失的，你应负责赔偿。
      </p>
      <h2>6.关于通知</h2>
      <p>
        6.1魔果可能会以网页公告、网页提示、电子邮箱、手机短信、常规的信件传送、您注册的本服务帐号的管理系统内发送站内信等方式中的一种或多种，向您送达关于本服务的各种规则、通知、提示等信息，该等信息一经魔果采取前述任何一种方式公布或发送，即视为您已经接受并同意，对您产生约束力。
        <b>
          若您不接受的，请您书面通知魔果并停止使用本服务，否则视为您已经接受、同意。</b
        >
      </p>
      <p>
        6.2若由于您提供的电子邮箱、手机号码、通讯地址等信息错误，导致您未收到相关规则、通知、提示等信息的，您同意仍然视为您已经收到相关信息并受其约束，
        <b> 一切后果及责任由您自行承担。</b>
      </p>
      <p>
        6.3您也同意魔果及其关联公司或合作伙伴可以向您的电子邮件、手机号码等发送可能与本服务不相关的其他各类信息包括但不限于商业广告等。
      </p>
      <p>
        6.4若您有事项需要通知魔果的，应当按照本服务对外正式公布的联系方式书面通知魔果。
      </p>
      <h2>7.知识产权</h2>
      <p>
        7.1魔果及其关联公司在本服务中提供的信息内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权均归魔果及其关联公司所有，依法属于用户、分享者及其他第三方所有的除外。除另有特别声明外，魔果提供本服务时所依托软件的著作权、专利权及其他知识产权均为合法所有。魔果在本服务中所使用的“魔果”、“魔果云课”及魔果云课各种形态的LOGO或平台形象等商业标识，其著作权或商标权归魔果及其关联公司所有。上述及其他任何魔果及其关联公司依法拥有的知识产权均受到法律保护，未经魔果及其关联公司书面许可，您不得以任何形式进行使用或创造相关衍生作品。
      </p>
      <p>
        7.2您仅拥有依照本协议约定合法使用本服务或相关API的权利，与本服务相关的API相关的著作权、专利权等相关全部权利归魔果及其关联公司所有。未经魔果及其关联公司书面许可，您不得违约或违法使用，不得向任何单位或个人出售、转让、转授权上述的代码、API及开发工具等。
      </p>
      <p>
        7.3
        <b>您同意并理解：</b>
        您作为知识分享者享有您分享合法内容的版权。如您将在魔果云课上录制的分享视频使用在其它平台或机构，开展与本服务协议约定内容相关或类似的合作时，您保证前述分享内容、服务与合作与您根据本协议提供的内容、服务与合作有足以防止混淆的区别。
        <b>
          您并承诺在其它平台或机构提供的与本协议约定接近的内容或服务售价不得低于在魔果云课平台的售价，否则魔果有权拒绝结算费用。</b
        >
      </p>
      <p>
        <b
          >7.4您同意并理解：为了维护双方权益，魔果有权对侵犯您在魔果云课平台分享内容的著作权的行为予以打击和制止，包括但不限于通过发函、投诉、诉讼等各种方式。为协助魔果完成该维权事宜，您同意根据魔果的要求提供充分的协助，如提供版权证明文件、授权书等。</b
        >
      </p>
      <h2>8.保密条款</h2>
      <p>
        8.1
        <b> 您保证：</b>
        您通过签订和履行本协议接触和其他渠道得知的，有关魔果的商业秘密及其他未披露的资料和信息均应严格保密；非经魔果书面同意，您不得向第三方泄露、给予或转让上述信息。
      </p>
      <p>
        8.2
        <b>您保证：</b>
        您不得向第三方泄露通过签订和履行本协议而获知的魔果及关联公司的任何信息。
      </p>
      <p>
        8.3
        <b>本协议终止后，本保密条款仍具有法律效力。</b>
      </p>
      <h2>9.其他</h2>
      <p>
        9.1魔果可能不断发布的关于本服务的其他相关协议、规则等内容均为本协议的附件，是本协议不可分割的部分，与本协议具有同等法律效力。
      </p>
      <p>
        9.2本协议内容同时包括及魔果可能不断发布的关于本服务的其他相关协议、规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。一经注册或使用本协议下任何服务，即视为您已阅读并同意接受本协议及上述内容的约束。魔果有权在必要时单方修改本协议或上述内容，相关内容变更后，如果您继续使用本服务，即视为您已接受修改后的相关内容。如果您不接受修改后的相关内容，应当停止使用相关服务。
      </p>
      <p>9.3本协议签订地为中华人民共和国北京市。</p>
      <p>
        9.4本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
      </p>
      <p>
        <b
          >9.5若您和魔果在履行本协议的过程中，如发生任何争议，则双方应首先进行友好协商解决；协议不成的，任何一方有权向北京市朝阳区人民法院提起诉讼解决。</b
        >
      </p>
      <p>
        9.6本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
      </p>
      <p>（完）</p>

      <h2 style="margin: 60px 0 30px">附件</h2>
      <h1>魔果云课结算说明</h1>
      <p>更新日期：2024年06月10日</p>
      <p>生效日期：2024年06月10日</p>
      <p>
        《魔果云课结算说明》（以下简称为结算说明）作为与魔果云课合作方确认结算的说明文档，对结算双方都具有法律效力。结算说明如有版本更新，将通过魔果云课提前告知合作方，并以魔果云课官网公示的最新版本为准。
      </p>
      <h3>一、结算说明</h3>
      <p>
        1.1订单完成：订单支付成功且学员获得课程使用权视为订单完成，订单完成后的次日进入待结算流程。
      </p>
      <p>
        1.2冻结期：订单完成后至之后的7天允许用户发起退款，退款发起后最长等待机构人工处理时间为7天（7天未处理则自动同意退款并扣除相应金额的余额）；即一笔订单对应的金额最短7天，最长14天为订单对应金额的冻结期。冻结期间，分享者或机构无法提取对应资金。
      </p>
      <p>
        1.3结算与提现：至冻结期结束后，该订单对应金额转变为待提现状态，可提取至分享者或机构配置的收款账户，且提现同时会根据平台与机构约定比例收取服务费（服务费收费标准请参见相关条款或线下签署协议）。
      </p>
      <p>
        1.4账号余额资金显示时间：订单结算后，根据平台统计周期进行周期性更新显示，余额中会标记总数额、冻结部分数额、待提现部分数额。
      </p>
      <p>
        1.5合作方对结算数据有异议，可通过入驻登记的联系方式发送数据复核申请。魔果云课财务人员在30个工作日内完成复核并给予答复。数据有误部分，将在复核完成的次日结算，不影响前期结算。
      </p>
      <p>1.6魔果云课指定联系方式，电子邮箱：service@moguoyunke.com</p>
      <h3>二、资费标准</h3>
      <p>
        魔果云课平台为知识分享者提供服务，分享者通过平台服务获取相应的收益。
        <b>
          除了相关运营合作协议的特殊约定外，魔果云课将根据分享者通过平台服务所获取的收益，收取相关费用，包括但不限于平台服务费（含带宽技术服务费等）等。</b
        >
        具体资费标准如下：
      </p>
      <div class="list-wrap">
        <p>
          （1）平台服务费。常规模式下情况下魔果云课平台收取平台服务费
          <b>【5%】；单独签署协议时以具体签署的协议为准。</b>
        </p>
        <p>
          （2）其他。魔果云课与知识分享者个别约定产生的其他费用如代运营服务费，以双方约定为准。
        </p>
      </div>

      <h3>三、退款</h3>
      <p>
        <b
          >学员退款依据《消费者权益保护法》的相关规定，若魔果云课收费用户与合作方在订单完成之日起7天内关于退款达成一致，合作方确认后，按照合作方与用户确认后的金额进行退款。若由魔果云课代其向学员支付的退款，魔果云课将在结算金额中扣除退款部分。</b
        >
      </p>
      <h3>四、双方结算义务</h3>
      <p>
        <b
          >4.1魔果云课作为开放平台，无代扣代缴合作方所得收益税费的义务。针对合作方提供给学员的各项服务收入，由合作方自行承担所得收益的税费。</b
        >
      </p>
      <p>
        <b>
          4.2付费学员针对付费内容提出的开票请求，由合作方与学员自行协商解决。</b
        >
      </p>
      <p>
        <b> 4.3魔果云课可为合作方提供平台收取服务费相关的合法发票。</b>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style scoped src="../../assets/css/zx-agreement.css"></style>

<style scoped></style>
